import { motion } from 'framer-motion';
import {
  PiggyBank,
  Award,
  Briefcase,
  CheckCircle2,
  Languages,
  Plane,
  LucideIcon,
} from 'lucide-react';
import { fadeUp, staggerContainer, viewportOnce } from './Animations';
import { program } from '@/lib/program-data';

const iconMap: Record<string, LucideIcon> = {
  'piggy-bank': PiggyBank,
  award: Award,
  briefcase: Briefcase,
  'check-circle': CheckCircle2,
  languages: Languages,
  plane: Plane,
};

export default function USPGrid() {
  return (
    <section id="usps" className="section-padding bg-[#fafafa]">
      <div className="container-content">

        {/* HEADER */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={fadeUp}
          className="mx-auto max-w-3xl text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-edept-orange">
            Why this program
          </p>

          <h2 className="mt-3 text-3xl text-edept-dark sm:text-4xl">
            Built for students who want the world, without the price tag
          </h2>
        </motion.div>

        {/* USP GRID */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={staggerContainer}
          className="
            mx-auto
            mt-14
            grid
            max-w-5xl
            grid-cols-1
            gap-x-12
            gap-y-12
            sm:grid-cols-2
            lg:grid-cols-6
          "
        >
          {program.usps.map((usp, index) => {
            const Icon = iconMap[usp.icon] ?? CheckCircle2;

            return (
              <motion.div
                key={usp.title}
                variants={fadeUp}
                className={`
                  flex
                  flex-col
                  items-center
                  text-center
                  lg:col-span-2

                  ${index === 3 ? 'lg:col-start-2' : ''}
                  ${index === 4 ? 'lg:col-start-4' : ''}
                `}
              >
                {/* ICON */}
                <div className="mb-5 flex items-center justify-center">
                  <Icon
                    aria-hidden="true"
                    size={34}
                    strokeWidth={1.7}
                    className="
                      text-edept-orange
                      transition-transform
                      duration-300
                      group-hover:scale-105
                    "
                  />
                </div>

                {/* TITLE */}
                <h3
                  className="
                    max-w-[220px]
                    text-lg
                    font-semibold
                    leading-snug
                    text-slate-900
                  "
                >
                  {usp.title}
                </h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}